import { useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

export const Dropdown = ({ name, value, options, onSelect, disabled = false, disableClearable = false }) => {
    // const customization = useSelector((state) => state.customization)
    const findMatchingOptions = (options = [], value) => options.find((option: any) => option.name === value)
    const getDefaultOptionValue = () => ''
    const [internalValue, setInternalValue] = useState(value ?? 'choose an option')

    const handleChange = (e) => {
        const value = e.target.value
        setInternalValue(value)
        onSelect(value)
    }

    return (
        <div className="w-100">
            <select
                id={name}
                disabled={disabled}
                value={internalValue}
                onChange={handleChange}
                className={`w-full py-2 px-3 border rounded-lg shadow-sm focus:outline-none focus:ring focus:border-blue-500 ${disabled ? 'bg-gray-200 cursor-not-allowed' : 'bg-white'}`}
            >
                {!disableClearable && <option value="">Select an option</option>}
                {options?.map((option) => (
                    <option key={option.name} value={option.name}>
                        {option.label}
                    </option>
                ))}
            </select>
            {/* <div className="absolute z-10 mt-1 border border-gray-300 rounded-lg shadow-lg bg-white w-full">
                {options.map((option) => (
                    <div key={option.name} className="p-2 hover:bg-gray-200 cursor-pointer">
                        <div className="flex flex-col">
                            <span className="text-base font-semibold">{option.label}</span>
                            {option.description && (
                                <span className={`text-sm ${customization.isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                                    {option.description}
                                </span>
                            )}
                        </div>
                    </div>
                ))}
            </div> */}
        </div>
    )
}

Dropdown.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    options: PropTypes.array,
    onSelect: PropTypes.func,
    disabled: PropTypes.bool,
    disableClearable: PropTypes.bool
}
